// extracted by mini-css-extract-plugin
export default {"chart_products":"styles_chart_products__rG-Qu","chart_products_item":"styles_chart_products_item__EVdLl"};